// src/services/ProfileService.js

import http from "./http";

const ProfileService = {
  /**
   * Check if user has permission for a pages configuration
   * @param {string} pagesConfigurationId - The page configuration ID (which is the URL value)
   * @returns {Promise<boolean>} - Returns true if user has permission, false otherwise
   */
  checkPagesConfigurationPermission: async (pagesConfigurationId) => {
    // Skip API call when ID is missing or zero
    if (
      pagesConfigurationId === undefined ||
      pagesConfigurationId === null ||
      String(pagesConfigurationId).trim() === "" ||
      Number(pagesConfigurationId) === 0
    ) {
      return true;
    }
    try {
      const response = await http.GET(`profiles/pages-permissions/check-access?pagesConfigurationId=${pagesConfigurationId}`);
      if (response.status === 200 && response.data) {
        const responseData = response.data;
        if (responseData.code === 200 && responseData.data !== undefined) {
          return responseData.data; // boolean value
        }
      }
      return false;
    } catch (error) {
      console.error('Error checking pages configuration permission:', error);
      return false; // Default to false on error
    }
  }
};

export default ProfileService;

